@let displayText = text() ?? ('common.and_more_no_count' | translate);

@if (routerLink(); as link) {
  <a [routerLink]="link">
    <span class="font-italic small mt-2">{{ displayText }}</span>
  </a>
} @else {
  <span class="font-italic small mt-2">{{ displayText }}</span>
}
